<template>
  <div id="advancedKeysComponent">
    <div class="top">
      <p v-wave class="tabName" :class="item.status ? 'tabNameActive' : ''" v-for="item in tabList" :key="item.value" @click="tabChange(item)">
        {{$t(item.name)}}
      </p>
    </div>
    <div class="tips">
      <el-popover
        placement="right"
        :title="$t('说明')"
        width="400"
        trigger="hover">
        <div>
          <p style="line-height: 0.25rem;margin: 0.2rem 0" v-show="tabList[0].status">
            {{$t('提示内容13')}}
          </p>
          <p style="line-height: 0.25rem;margin: 0.2rem 0" v-show="tabList[0].status">
            {{$t('提示内容14')}}
          </p>
          <p style="line-height: 0.25rem;margin: 0.2rem 0">
            {{$t('提示内容15')}}
          </p>
        </div>
        <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
      </el-popover>
    </div>
    <div class="keys">
      <div class="keysIn">
        <div v-show="tabList[0].status" class="btns_box animate__animated animate__fadeIn">
          <div class="btns">
            <div class="letter"
                 v-for="(letter, index) in key_name_replace[0]"
                 :key="letter"
                 @click="keyChange(letter)">
              <div class="button_out" :class="[[4,8].includes(index) ? 'interval1' : '',index === 0 ? 'interval6' : '',index === 62 ? 'interval7' : '',index === 75 ? 'interval5' : '',[12,29,46,62,83].includes(index) ? 'interval4' : '',index === 29 ? 'keyBig1': '',index === 33 || index === 46 ? 'keyBig2': '',[50].includes(index) ? 'keyBig3' : '',[62,63].includes(index) ? 'keyBig4' : '',index === 74 ? 'keyBig7' : '',[76,77,78,80,81,82,83].includes(index) ? 'keyBig5' : '',index === 79 ? 'keyBig6' : '']">
                <button v-wave class="alphabet-button">
                  {{ KeyStrings[letter] }}
                </button>
              </div>
            </div>
          </div>
          <div class="btns btns_other">
            <div class="letter"
                 v-for="(letter) in key_name_pad"
                 :key="letter"
                 @click="keyChange(letter)">
              <div class="button_out" :class="letter === 98 ? 'keyBig1' : ''">
                <button v-wave class="alphabet-button">
                  {{ KeyStrings[letter] }}
                </button>
              </div>
            </div>
          </div>
          <div class="btns btns_pad">
            <div class="letter"
                 v-for="(letter) in key_name_pad1"
                 :key="letter"
                 @click="keyChange(letter)">
              <div class="button_out" :class="letter === 87 || letter === 88 ? 'keyBig8' : ''">
                <button v-wave class="alphabet-button">
                  {{ KeyStrings[letter] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tabList[1].status" class="btns_box animate__animated animate__fadeIn">
          <!--    按键部分     -->
          <div class="keys">
            <div class="btns">
              <div class="letter"
                   v-for="(letter, index) in key_name_replace[0]"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="[[4,8].includes(index) ? 'interval1' : '',index === 0 ? 'interval6' : '',index === 62 ? 'interval7' : '',index === 75 ? 'interval5' : '',[12,29,46,62,83].includes(index) ? 'interval4' : '',index === 29 ? 'keyBig1': '',index === 33 || index === 46 ? 'keyBig2': '',[50].includes(index) ? 'keyBig3' : '',[62,63].includes(index) ? 'keyBig4' : '',index === 74 ? 'keyBig7' : '',[76,77,78,80,81,82,83].includes(index) ? 'keyBig5' : '',index === 79 ? 'keyBig6' : '']">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_other">
              <div class="letter"
                   v-for="(letter) in key_name_pad"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="letter === 98 ? 'keyBig1' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_pad">
              <div class="letter"
                   v-for="(letter) in key_name_pad1"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="letter === 87 || letter === 88 ? 'keyBig8' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_pad btns_mouse">
              <div class="letter"
                   v-for="(letter) in key_name_mouse"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <!--    组合     -->
          <div class="group">
            <div class="groupOriginSwitch">
              <h4>{{$t('滑块标题13')}}</h4>
              <div class="checkbox-wrapper-8">
                <el-switch  v-model="DKSOriginCover" :disabled="!equipmentVersion" @click="DKSOriginCoverClick"></el-switch>
              </div>
            </div>
            <div class="groupBoxs">
              <div class="box" v-for="(item,index) in groupKeysList" :key="index" @click="boxClick(index,'1')">
                <div v-wave class="box_top" :class="item.status ? 'box_top_select' : '' ">
                  <p>{{KeyStrings[item.value]}}</p>
                </div>
                <p class="box_bottom" @click.stop="deleteClick(index,'1')">
                  <img src="../assets/img/close.png" alt="">
                </p>
              </div>
            </div>
            <div class="groupButtons">
              <button class="button" @click="groupClear"><i class="el-icon-refresh"></i>{{$t('清空')}}</button>
              <button class="button" @click="groupConfirm"><i class="el-icon-check"></i>{{$t('确认')}}</button>
            </div>
          </div>
        </div>
        <div v-show="tabList[2].status" class="btns_box animate__animated animate__fadeIn">
          <!--    按键部分     -->
          <div class="keys">
            <div class="btns">
              <div class="letter"
                   v-for="(letter, index) in key_name_replace[0]"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="[[4,8].includes(index) ? 'interval1' : '',index === 0 ? 'interval6' : '',index === 62 ? 'interval7' : '',index === 75 ? 'interval5' : '',[12,29,46,62,83].includes(index) ? 'interval4' : '',index === 29 ? 'keyBig1': '',index === 33 || index === 46 ? 'keyBig2': '',[50].includes(index) ? 'keyBig3' : '',[62,63].includes(index) ? 'keyBig4' : '',index === 74 ? 'keyBig7' : '',[76,77,78,80,81,82,83].includes(index) ? 'keyBig5' : '',index === 79 ? 'keyBig6' : '']">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_other">
              <div class="letter"
                   v-for="(letter) in key_name_pad"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="letter === 98 ? 'keyBig1' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_pad">
              <div class="letter"
                   v-for="(letter) in key_name_pad1"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out" :class="letter === 87 || letter === 88 ? 'keyBig8' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="btns btns_pad btns_mouse">
              <div class="letter"
                   v-for="(letter) in key_name_mouse"
                   :key="letter"
                   @click="keyChange(letter)">
                <div class="button_out">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <!--    DKS     -->
          <div class="group">
            <div class="DKSTime">
              <p class="select">
                <label>{{$t('单次按下时间(Tick)')}}</label>
                <el-select size="mini" v-model="DKSTime.singleTime">
                  <el-option v-for="item in numbers1" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </p>
              <p class="select">
                <label>{{$t('延迟时间(Tick)')}}</label>
                <el-select size="mini" v-model="DKSTime.delayTime">
                  <el-option v-for="item in numbers2" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </p>
              <p class="select">
                <label>{{$t('随机延迟时间(Tick)')}}</label>
                <el-select size="mini" v-model="DKSTime.randomTime">
                  <el-option v-for="item in numbers2" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </p>
              <div class="originSwitch">
                <h4>{{$t('滑块标题13')}}</h4>
                <div class="checkbox-wrapper-8">
                  <el-switch  v-model="DKSOriginCover" :disabled="!equipmentVersion" @click="DKSOriginCoverClick"></el-switch>
                </div>
              </div>
            </div>
            <div class="DKSBoxs">
              <div class="box" v-for="(item,index) in DKSKeysList" :key="index" @click="dksModeClick(index)">
                <div class="keyButton" :class="item.status ? 'keyButton_select' : '' " @click="boxClick(index,'2')">
                  <p>{{KeyStrings[item.value]}}</p>
                  <div class="box_bottom" @click.stop="deleteClick(index,'2')">
                    <img src="../assets/img/close.png" alt="">
                  </div>
                </div>
                <div class="keyDKSModeBox">
                  <div class="keyDKSMode">
                    <p class="icon" @mousedown="DKSMousedown($event,index,0)"><i class="el-icon-circle-plus"></i></p>
                    <p class="line"></p>
                    <!--                    <p class="select animate__animated animate__fadeIn" v-show="item.status">-->
                    <!--                      <el-select size="mini" v-model="item.triggerMode1">-->
                    <!--                        <el-option :label="$t('不触发')" :value="0"></el-option>-->
                    <!--                        <el-option :label="$t('持续')" :value="1"></el-option>-->
                    <!--                        <el-option :label="$t('单次')" :value="2"></el-option>-->
                    <!--                      </el-select>-->
                    <!--                    </p>-->
                    <p class="journey" v-show="index === 0" @click="journeyClick('1')"><i class="el-icon-bottom"></i>{{ DKSJourney.topJourney }}mm </p>
                    <!--                    <p class="cover" :style="{width: getCoverWidth(item.triggerMode1)}"></p>-->
                    <p class="cover" :style="{width: DKSKeysList[index].ModeCover[0].currentWidth + 'rem'}" @click="coverClick(index,0)"></p>
                  </div>
                  <div class="keyDKSMode">
                    <p class="icon" @mousedown="DKSMousedown($event,index,1)"><i class="el-icon-circle-plus"></i></p>
                    <p class="line"></p>
                    <!--                    <p class="select animate__animated animate__fadeIn" v-show="item.status">-->
                    <!--                      <el-select size="mini" v-model="item.triggerMode2">-->
                    <!--                        <el-option :label="$t('不触发')" :value="0"></el-option>-->
                    <!--                        <el-option :label="$t('持续')" :value="1"></el-option>-->
                    <!--                        <el-option :label="$t('单次')" :value="2"></el-option>-->
                    <!--                      </el-select>-->
                    <!--                    </p>-->
                    <p class="journey" v-show="index === 0" @click="journeyClick('2')"><i class="el-icon-download"></i>{{ DKSJourney.bottomJourney }}mm</p>
                    <!--                    <p class="cover" :style="{width: getCoverWidth(item.triggerMode2)}"></p>-->
                    <p class="cover" :style="{width: DKSKeysList[index].ModeCover[1].currentWidth + 'rem'}" @click="coverClick(index,1)"></p>
                  </div>
                  <div class="keyDKSMode">
                    <p class="icon" @mousedown="DKSMousedown($event,index,2)"><i class="el-icon-circle-plus"></i></p>
                    <p class="line"></p>
                    <!--                    <p class="select animate__animated animate__fadeIn" v-show="item.status">-->
                    <!--                      <el-select size="mini" v-model="item.triggerMode3">-->
                    <!--                        <el-option :label="$t('不触发')" :value="0"></el-option>-->
                    <!--                        <el-option :label="$t('持续')" :value="1"></el-option>-->
                    <!--                        <el-option :label="$t('单次')" :value="2"></el-option>-->
                    <!--                      </el-select>-->
                    <!--                    </p>-->
                    <p class="journey" v-show="index === 0" @click="journeyClick('2')"><i class="el-icon-upload2"></i>{{ DKSJourney.bottomJourney }}mm</p>
                    <!--                    <p class="cover" :style="{width: getCoverWidth(item.triggerMode3)}"></p>-->
                    <p class="cover" :style="{width: DKSKeysList[index].ModeCover[2].currentWidth + 'rem'}" @click="coverClick(index,2)"></p>
                  </div>
                  <div class="keyDKSMode">
                    <p class="icon" @mousedown="DKSMousedown($event,index,3)"><i class="el-icon-circle-plus"></i></p>
                    <!--                    <p class="select animate__animated animate__fadeIn" v-show="item.status">-->
                    <!--                      <el-select size="mini" v-model="item.triggerMode4">-->
                    <!--                        <el-option :label="$t('不触发')" :value="0"></el-option>-->
                    <!--                        <el-option :label="$t('单次')" :value="2"></el-option>-->
                    <!--                      </el-select>-->
                    <!--                    </p>-->
                    <p class="journey" v-show="index === 0" @click="journeyClick('1')"><i class="el-icon-top"></i>{{ DKSJourney.topJourney }}mm</p>
                    <!--                    <p class="cover" :style="{width: getCoverWidth(item.triggerMode4)}"></p>-->
                    <p class="cover" :style="{width: DKSKeysList[index].ModeCover[3].currentWidth + 'rem'}" @click="coverClick(index,3)"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="Buttons">
              <button class="button" @click="DKSKeysListClear"><i class="el-icon-refresh"></i>{{$t('清空')}}</button>
              <button class="button" @click="DKSConfirm"><i class="el-icon-check"></i>{{$t('确认')}}</button>
            </div>
          </div>
        </div>
        <!--       <div class="keysCover" v-show="tabList[2].status"></div>-->
      </div>
      <!--     <div class="keysCover" v-show="tabList[2].status"></div>-->
    </div>

    <el-dialog
      :title="$t(DKSJourneyTitle)"
      :visible.sync="showDKSJourney"
      width="30%"
      :modal-append-to-body="true"
      :append-to-body="true"
      top="45vh">
      <div class="advance">
        <el-slider v-if="DKSJourneyTitle === 'DKS顶部触发键程'" :show-tooltip="false" v-model="DKSJourney.topJourney" :min="0.1" :max="3.2" :step="0.1" @change="topJourneyChange"></el-slider>
        <el-slider v-else :show-tooltip="false" v-model="DKSJourney.bottomJourney" :min="bottomJourneyMin" :max="3.3" :step="0.1"></el-slider>
        <p class="numericalValue">{{ DKSJourneyTitle === 'DKS顶部触发键程' ?  DKSJourney.topJourney : DKSJourney.bottomJourney }}</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {key_name_replace, KeyCodes, KeyStrings} from '@/store/state'
import EventBus from "@/store/eventBus";
import {convertToArrayWithHighLowDigits, convertToBase10} from "@/store/utils";

export default {
  name: "advancedKeysComponent",
  data() {
    return {
      key_name_replace: key_name_replace,
      key_name_pad: [83,84,85,95,96,97,92,93,94,89,90,91,98,99],
      key_name_pad1: [86,87,88],
      key_name_mouse: [251,252,253,254,255],
      KeyStrings: KeyStrings,
      KeyCodes: KeyCodes,
      tabList:[
        {
          name: '后覆盖(SOCD)',
          value: '0',
          status: true
        },
        {
          name: '组合键',
          value: '1',
          status: false,
        },
        {
          name: 'DKS',
          value: '2',
          status: false
        }
      ],
      groupKeysList: [
        {
          value: 1000,
          status: false,
        },
        {
          value: 1000,
          status: false,
        },
        {
          value: 1000,
          status: false,
        },
        {
          value: 1000,
          status: false,
        }
      ],
      DKSKeysList: [
        {
          value: 1000,
          status: false,
          selectStatus: false,
          triggerMode1: 0,
          triggerMode2: 0,
          triggerMode3: 0,
          triggerMode4: 0,
          ModeCover: [
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            }
          ]
        },
        {
          value: 1000,
          status: false,
          selectStatus: false,
          triggerMode1: 0,
          triggerMode2: 0,
          triggerMode3: 0,
          triggerMode4: 0,
          ModeCover: [
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            }
          ]
        },
        {
          value: 1000,
          status: false,
          selectStatus: false,
          triggerMode1: 0,
          triggerMode2: 0,
          triggerMode3: 0,
          triggerMode4: 0,
          ModeCover: [
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            }
          ]
        },
        {
          value: 1000,
          status: false,
          selectStatus: false,
          triggerMode1: 0,
          triggerMode2: 0,
          triggerMode3: 0,
          triggerMode4: 0,
          ModeCover: [
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            },
            {
              startX: 0, // 鼠标起始位置
              currentWidth: 0, // 实时宽度
              isResizing: false, // 是否正在调整大小
            }
          ]
        }
      ],
      DKSTime: {
        singleTime: 1,
        delayTime: 0,
        randomTime: 0
      },
      DKSJourney:{
        topJourney: 1,
        bottomJourney: 3
      },
      DKSOriginCover: false,
      SelectedKey: {
        index: null,
        status: false
      },
      numbers1: Array.from({ length: 50 }, (_, i) => i + 1),
      numbers2: Array.from({ length: 11 }, (_, i) => i),
      showDKSJourney: false,
      DKSJourneyTitle: '',
      version: 0,
      productId: null,
      resizeHandler: null,
      stopResizeHandler: null
    }
  },
  computed: {
    // 根据配列和层返回key数组
    bottomJourneyMin() {
      if (this.DKSJourney.topJourney === 3.2) {
        return 3.3
      } else {
        return this.DKSJourney.topJourney + 0.1
      }
    },
    equipmentVersion() {
      if (this.productId === 13694) { // wob75
        return this.version >= 18
      } else {
        return false
      }
    }
  },
  mounted() {
    EventBus.$on('advancedKeyClick',this.getAdvancedKeyClick)
    EventBus.$on('clearGroupKeys',this.clearGroupKeys)
    EventBus.$on('getFirmwareVersion',this.getFirmwareVersion)
    EventBus.$on('enterKeyboard',this.handleEnterKeyboard)
  },
  methods: {
    handleEnterKeyboard(data) {
      this.productId = data.productId
    },
    DKSOriginCoverClick() {
      if (!this.equipmentVersion) {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容89'),
          offset: 100
        })
      }
    },
    DKSMousedown(event,index1,index2) {
      // 记录初始位置和宽度
      this.DKSKeysList[index1].ModeCover[index2].isResizing = true
      this.DKSKeysList[index1].ModeCover[index2].startX = event.clientX
      this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0.2

      if (index2 === 0) {
        this.DKSKeysList[index1].triggerMode1 = 2
      } else if (index2 === 1) {
        this.DKSKeysList[index1].triggerMode2 = 2
      } else if (index2 === 2) {
        this.DKSKeysList[index1].triggerMode3 = 2
      } else if (index2 === 3) {
        this.DKSKeysList[index1].triggerMode4 = 2
      }

      this.resizeHandler = (e) => this.resize(e,index1,index2)
      this.stopResizeHandler = (e) => this.stopResize(e,index1,index2)

      // 监听鼠标移动和释放
      document.addEventListener("mousemove",this.resizeHandler)
      document.addEventListener("mouseup",this.stopResizeHandler)
    },
    resize(event,index1,index2) {
      if (!this.DKSKeysList[index1].ModeCover[index2].isResizing) return

      // 根据鼠标滑动距离计算宽度
      const deltaX = event.clientX - this.DKSKeysList[index1].ModeCover[index2].startX
      let num = 0
      switch (index2) {
        case 0:
          num = 420
          break;
        case 1:
          num = 280
          break;
        case 2:
          num = 140
          break;
        case 3:
          num = 20
          break;
      }
      if (deltaX > 20) {
        this.DKSKeysList[index1].ModeCover[index2].currentWidth = (Math.min(deltaX,num))/100
      }
    },
    stopResize(event,index1,index2) {
      if (index2 === 0) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth < 0.6) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0.2
          this.DKSKeysList[index1].triggerMode1 = 2
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 0.6 && this.DKSKeysList[index1].ModeCover[index2].currentWidth < 2) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 1.4
          this.DKSKeysList[index1].triggerMode1 = 1
          // if (this.DKSKeysList[index1].ModeCover[1].currentWidth === 1.4) {
          //   this.DKSKeysList[index1].ModeCover[1].currentWidth = 0
          //   this.DKSKeysList[index1].ModeCover[index2].currentWidth = 2.8
          //   this.DKSKeysList[index1].triggerMode2 = 1
          // } else if (this.DKSKeysList[index1].ModeCover[1].currentWidth === 2.8) {
          //   this.DKSKeysList[index1].ModeCover[1].currentWidth = 0
          //   this.DKSKeysList[index1].ModeCover[index2].currentWidth = 4.2
          //   this.DKSKeysList[index1].triggerMode2 = 1
          //   this.DKSKeysList[index1].triggerMode3 = 1
          // }
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 2 && this.DKSKeysList[index1].ModeCover[index2].currentWidth < 3.4) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 2.8
          this.DKSKeysList[index1].triggerMode1 = 1
          this.DKSKeysList[index1].triggerMode2 = 1
          if (this.DKSKeysList[index1].ModeCover[1].currentWidth === 1.4 || this.DKSKeysList[index1].ModeCover[1].currentWidth === 0.2) {
            this.DKSKeysList[index1].ModeCover[1].currentWidth = 0
          } else if (this.DKSKeysList[index1].ModeCover[1].currentWidth === 2.8) {
            this.DKSKeysList[index1].ModeCover[1].currentWidth = 0
            this.DKSKeysList[index1].ModeCover[index2].currentWidth = 4.2
            this.DKSKeysList[index1].triggerMode3 = 1
          }
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 3.4) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 4.2
          this.DKSKeysList[index1].triggerMode1 = 1
          this.DKSKeysList[index1].triggerMode2 = 1
          this.DKSKeysList[index1].triggerMode3 = 1
          this.DKSKeysList[index1].ModeCover[1].currentWidth = 0
          this.DKSKeysList[index1].ModeCover[2].currentWidth = 0
        }
      } else if (index2 === 1) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth < 0.6) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0.2
          this.DKSKeysList[index1].triggerMode2 = 2
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 0.6 && this.DKSKeysList[index1].ModeCover[index2].currentWidth < 2) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 1.4
          this.DKSKeysList[index1].triggerMode2 = 1
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 2 && this.DKSKeysList[index1].ModeCover[index2].currentWidth < 2.8) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 2.8
          this.DKSKeysList[index1].triggerMode2 = 1
          this.DKSKeysList[index1].triggerMode3 = 1
          this.DKSKeysList[index1].ModeCover[2].currentWidth = 0
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 2.8) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 2.8
          this.DKSKeysList[index1].triggerMode2 = 1
          this.DKSKeysList[index1].triggerMode3 = 1
          this.DKSKeysList[index1].ModeCover[2].currentWidth = 0
        }
      } else if (index2 === 2) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth < 0.6) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0.2
          this.DKSKeysList[index1].triggerMode3 = 2
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 0.6 && this.DKSKeysList[index1].ModeCover[index2].currentWidth < 1.4) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 1.4
          this.DKSKeysList[index1].triggerMode3 = 1
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth >= 1.4) {
          this.DKSKeysList[index1].ModeCover[index2].currentWidth = 1.4
          this.DKSKeysList[index1].triggerMode3 = 1
        }
      } else if (index2 === 3) {
        this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0.2
        this.DKSKeysList[index1].triggerMode4 = 2
      }
      // 停止调整
      this.DKSKeysList[index1].ModeCover[index2].isResizing = false;
      document.removeEventListener("mousemove", this.resizeHandler);
      document.removeEventListener("mouseup", this.stopResizeHandler);
    },
    coverClick(index1,index2) {
      if (index2 === 0) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 0.2 || this.DKSKeysList[index1].ModeCover[index2].currentWidth === 1.4) {
          this.DKSKeysList[index1].triggerMode1 = 0
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 2.8) {
          this.DKSKeysList[index1].triggerMode1 = 0
          this.DKSKeysList[index1].triggerMode2 = 0
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 4.2) {
          this.DKSKeysList[index1].triggerMode1 = 0
          this.DKSKeysList[index1].triggerMode2 = 0
          this.DKSKeysList[index1].triggerMode3 = 0
        }
      } else if (index2 === 1) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 0.2 || this.DKSKeysList[index1].ModeCover[index2].currentWidth === 1.4) {
          this.DKSKeysList[index1].triggerMode2 = 0
        } else if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 2.8) {
          this.DKSKeysList[index1].triggerMode2 = 0
          this.DKSKeysList[index1].triggerMode3 = 0
        }
      } else if (index2 === 2) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 0.2 || this.DKSKeysList[index1].ModeCover[index2].currentWidth === 1.4) {
          this.DKSKeysList[index1].triggerMode3 = 0
        }
      } else if (index2 === 3) {
        if (this.DKSKeysList[index1].ModeCover[index2].currentWidth === 0.2) {
          this.DKSKeysList[index1].triggerMode4 = 0
        }
      }
      this.DKSKeysList[index1].ModeCover[index2].currentWidth = 0
      this.DKSKeysList[index1].ModeCover[index2].startX = 0
    },
    dksModeClick(index) {
      this.DKSKeysList.forEach((e,i) => {
        e.status = index === i;
      })
    },
    getFirmwareVersion(val) {
      this.version = val.version
    },
    topJourneyChange() {
      if (this.DKSJourney.topJourney === 3.2) {
        this.DKSJourney.bottomJourney = parseFloat((3.3).toFixed(1))
      } else {
        if(this.DKSJourney.bottomJourney <= this.DKSJourney.topJourney) {
          this.DKSJourney.bottomJourney = parseFloat((this.DKSJourney.topJourney + 0.1).toFixed(1))
        }
      }
    },
    journeyClick(sign) {
      this.showDKSJourney = true
      if (sign === '1') {
        this.DKSJourneyTitle = 'DKS顶部触发键程'
      } else {
        this.DKSJourneyTitle = 'DKS底部触发键程'
      }
    },
    DKSConfirm() {
      if (!this.equipmentVersion) {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容89'),
          offset: 100
        })
        return
      }
      if (this.SelectedKey.status) {
        let bol = false
        let bol1 = false
        this.DKSKeysList.forEach(e => {
          if (e.value !== 1000) {
            bol = true
            if (e.triggerMode1 !== 0 || e.triggerMode2 !== 0 || e.triggerMode3 !== 0 || e.triggerMode4 !== 0) {
              bol1 = true
            }
          }
        })
        if (bol) {
          if (bol1) {
            let arr = []
            this.DKSKeysList.forEach(e => {
              arr.push(e.triggerMode1)
              arr.push(e.triggerMode2)
              arr.push(e.triggerMode3)
              arr.push(e.triggerMode4)
            })

            let arr1 = []

            this.DKSKeysList.forEach(e => {
              arr1 = arr1.concat(convertToArrayWithHighLowDigits([e.value]))
            })

            let list1 = convertToArrayWithHighLowDigits([Number((this.DKSJourney.topJourney * 1000).toFixed(0))])
            let list2 = convertToArrayWithHighLowDigits([Number((this.DKSJourney.bottomJourney * 1000).toFixed(0))])
            let list3 = convertToArrayWithHighLowDigits([this.DKSTime.singleTime * 8])
            let list4 = convertToArrayWithHighLowDigits([this.DKSTime.delayTime * 8])
            let list5 = convertToArrayWithHighLowDigits([this.DKSTime.randomTime * 8])
            let list6 = Array(13).fill(255)
            let origin_cover = this.DKSOriginCover ? 0 : 1

            let arr2 = [...arr,...arr1,...list1,...list2,...list3,...list4,...list5,...list6]
            arr2.push(origin_cover)
            EventBus.$emit('DKSKeysConfirm',{
              key: this.SelectedKey.index,
              list: arr2
            })
            this.DKSKeysList.forEach(e => {
              e.status = false
            })
            this.SelectedKey.index = null
            this.SelectedKey.status = false
            this.DKSKeysListClear()
          } else {
            this.$notify.info({
              title: this.$t('提示'),
              message: this.$t('提示内容83'),
              offset: 100
            })
          }
        } else {
          this.$notify.info({
            title: this.$t('提示'),
            message: this.$t('提示内容84'),
            offset: 100
          })
        }
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容85'),
          offset: 100
        })
      }
    },
    DKSKeysListClear() {
      this.DKSKeysList.forEach(e => {
        e.value = 1000
        e.triggerMode1 = 0
        e.triggerMode2 = 0
        e.triggerMode3 = 0
        e.triggerMode4 = 0
        e.status = false
        for (let i = 0; i < e.ModeCover.length; i++) {
          e.ModeCover[i].currentWidth = 0
        }
      })
      this.DKSKeysList[0].status = true
    },
    getAdvancedKeyClick(obj) {
      this.SelectedKey.status = obj.status
      this.SelectedKey.index = obj.index
      if (this.SelectedKey.status) {
        this.groupKeysList[0].status = true
        this.groupKeysList[1].status = false
        this.groupKeysList[2].status = false
        this.groupKeysList[3].status = false
        this.DKSKeysList[0].status = true
        this.DKSKeysList[1].status = false
        this.DKSKeysList[2].status = false
        this.DKSKeysList[3].status = false
        if (obj.bindKeyMode === 1) { // 普通组合键
          let arr = convertToBase10(obj.bindKeysValue.slice(16,24))
          for (let i = 0; i < this.groupKeysList.length; i++) {
            this.groupKeysList[i].value = arr[i]
          }
          this.DKSOriginCover = obj.bindKeysValue[obj.bindKeysValue.length - 1] === 0
          this.tabChange({value: '1'})
          this.DKSKeysListClear()
        } else if (obj.bindKeyMode === 2) { // DKS按键
          // 反显按键值
          let arr = convertToBase10(obj.bindKeysValue.slice(16,24))
          for (let i = 0; i < this.DKSKeysList.length; i++) {
            this.DKSKeysList[i].value = arr[i]
          }

          // 反显按键每个阶段的触发形式
          for (let i = 0; i < 4; i++) {
            let arr = obj.bindKeysValue.slice(i*4,i*4+4)
            this.DKSKeysList[i].triggerMode1 = arr[0]
            this.DKSKeysList[i].triggerMode2 = arr[1]
            this.DKSKeysList[i].triggerMode3 = arr[2]
            this.DKSKeysList[i].triggerMode4 = arr[3]
            this.backDisplayWidth(i,arr[0],arr[1],arr[2],arr[3])
          }
          // 反显DKS顶部和底部的触发行程
          this.DKSJourney.topJourney = convertToBase10(obj.bindKeysValue.slice(24,26))[0] / 1000
          this.DKSJourney.bottomJourney = convertToBase10(obj.bindKeysValue.slice(26,28))[0] / 1000

          // 反显触发时间
          this.DKSTime.singleTime = convertToBase10(obj.bindKeysValue.slice(28,30))/8
          this.DKSTime.delayTime = convertToBase10(obj.bindKeysValue.slice(30,32))/8
          this.DKSTime.randomTime = convertToBase10(obj.bindKeysValue.slice(32,34))/8

          this.DKSOriginCover = obj.bindKeysValue[obj.bindKeysValue.length - 1] === 0
          this.tabChange({value: '2'})
          this.groupClear()
        } else if (obj.bindKeyMode === 0) { // 非组合键 和 非DKS
          this.DKSKeysListClear()
          this.groupClear()
          // this.DKSOriginCover = false
        }
      }
    },
    // 根据模式反显滑块宽度
    backDisplayWidth(i,mode1,mode2,mode3,mode4) {
      // if (mode1 === 0) { // 第一段模式为不触发
      //   this.DKSKeysList[i].ModeCover[0].currentWidth = 0
      // } else if (mode1 === 2) {
      //   this.DKSKeysList[i].ModeCover[0].currentWidth = 0.2
      // } else if (mode1 === 1) {
      //   if (mode2 === 1) {
      //     if (mode3 === 1) {
      //       this.DKSKeysList[i].ModeCover[0].currentWidth = 4.2
      //     } else {
      //       this.DKSKeysList[i].ModeCover[0].currentWidth = 2.8
      //     }
      //   } else {
      //     this.DKSKeysList[i].ModeCover[0].currentWidth = 1.4
      //   }
      // }

      if (mode1 === 0) {
        this.DKSKeysList[i].ModeCover[0].currentWidth = 0
      } else if (mode1 === 2) {
        this.DKSKeysList[i].ModeCover[0].currentWidth = 0.2
      } else if (mode1 === 1) {
        this.DKSKeysList[i].ModeCover[0].currentWidth = 1.4
      }

      if (mode2 === 0) {
        this.DKSKeysList[i].ModeCover[1].currentWidth = 0
      } else if (mode2 === 2) {
        this.DKSKeysList[i].ModeCover[1].currentWidth = 0.2
      } else if (mode2 === 1) {
        this.DKSKeysList[i].ModeCover[1].currentWidth = 1.4
      }

      if (mode3 === 0) {
        this.DKSKeysList[i].ModeCover[2].currentWidth = 0
      } else if (mode3 === 2) {
        this.DKSKeysList[i].ModeCover[2].currentWidth = 0.2
      } else if (mode3 === 1) {
        this.DKSKeysList[i].ModeCover[2].currentWidth = 1.4
      }

      if (mode4 === 0) {
        this.DKSKeysList[i].ModeCover[3].currentWidth = 0
      } else if (mode4 === 2) {
        this.DKSKeysList[i].ModeCover[3].currentWidth = 0.2
      }

      if (mode1 === 1 && mode2 === 1 && mode3 === 1) {
        this.DKSKeysList[i].ModeCover[0].currentWidth = 4.2
        this.DKSKeysList[i].ModeCover[1].currentWidth = 0
        this.DKSKeysList[i].ModeCover[2].currentWidth = 0
      } else if (mode1 === 1 && mode2 === 1 && mode3 !== 1) {
        this.DKSKeysList[i].ModeCover[0].currentWidth = 2.8
        this.DKSKeysList[i].ModeCover[1].currentWidth = 0
      } else if (mode1 !== 1 && mode2 === 1 && mode3 === 1) {
        this.DKSKeysList[i].ModeCover[1].currentWidth = 2.8
        this.DKSKeysList[i].ModeCover[2].currentWidth = 0
      }

    },
    clearGroupKeys(sign) {
      this.SelectedKey.status = false
      this.SelectedKey.index = null
      if (sign === '1') {
        this.groupKeysList.forEach(e => {
          e.value = 1000
        })
      } else if (sign === '2') {
        this.DKSKeysList.forEach(e => {
          e.value = 1000
          e.triggerMode1 = 0
          e.triggerMode2 = 0
          e.triggerMode3 = 0
          e.triggerMode4 = 0
          for (let i = 0; i < e.ModeCover.length; i++) {
            e.ModeCover[i].currentWidth = 0
          }
        })
      }
    },
    deleteClick(index,sign) {
      if (sign === '1') {
        this.groupKeysList[index].value = 1000
      } else {
        this.DKSKeysList[index].value = 1000
        this.DKSKeysList[index].triggerMode1 = 0
        this.DKSKeysList[index].triggerMode2 = 0
        this.DKSKeysList[index].triggerMode3 = 0
        this.DKSKeysList[index].triggerMode4 = 0
        for (let i = 0; i < this.DKSKeysList[index].ModeCover.length; i++) {
          this.DKSKeysList[index].ModeCover[i].currentWidth = 0
        }
      }
    },
    boxClick(index,sign) {
      if (sign === '1') {
        for (let i = 0; i < this.groupKeysList.length; i++) {
          if (i === index) {
            this.groupKeysList[i].status = !this.groupKeysList[i].status
          } else {
            this.groupKeysList[i].status = false
          }
        }
      } else {
        for (let i = 0; i < this.DKSKeysList.length; i++) {
          if (i === index) {
            this.DKSKeysList[i].status = !this.DKSKeysList[i].status
          } else {
            this.DKSKeysList[i].status = false
          }
        }
      }
    },
    tabChange(obj) {
      this.tabList.forEach(e => {
        if (obj.value === e.value) {
          e.status = true
          EventBus.$emit('advancedKeysComTab',e.value)
        } else {
          e.status = false
        }
      })
    },
    //按键选择
    keyChange(letter) {
      if (this.tabList[0].status) { // 在后覆盖
        EventBus.$emit('changeKey', letter)
      } else if (this.tabList[1].status) {
        let index = null
        this.groupKeysList.forEach((e,i) => {
          if (e.status) {
            e.value = letter
            index = i
          }
        })
        if (index !== null && index !== 3) {
          this.groupKeysList[index].status = false
          this.groupKeysList[index + 1].status = true
        }
      } else if (this.tabList[2].status) {
        let index = null
        this.DKSKeysList.forEach((e,i) => {
          if (e.status) {
            e.value = letter
            index = i
          }
        })
        if (index !== null && index !== 3) {
          this.DKSKeysList[index].status = false
          this.DKSKeysList[index + 1].status = true
        }
      }
    },
    groupConfirm() {
      if (!this.equipmentVersion) {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容89'),
          offset: 100
        })
        return
      }
      if (this.SelectedKey.status) {
        let bol = false
        this.groupKeysList.forEach(e => {
          if (e.value !== 1000) {
            bol = true
          }
        })
        if (bol) {
          EventBus.$emit('groupKeysConfirm',{
            key: this.SelectedKey.index,
            group: this.groupKeysList,
            cover: this.DKSOriginCover ? 0 : 1
          })
          this.groupKeysList.forEach(e => {
            e.status = false
          })
          this.SelectedKey.index = null
          this.SelectedKey.status = false
          this.groupClear()
        } else {
          this.$notify.info({
            title: this.$t('提示'),
            message: this.$t('提示内容86'),
            offset: 100
          })
        }
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容85'),
          offset: 100
        })
      }
    },
    groupClear() {
      this.groupKeysList.forEach(e => {
        e.value = 1000
        e.status = false
      })
      this.groupKeysList[0].status = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '../style/handle.scss';
#advancedKeysComponent {
  width: 100%;
  height: 100%;
  position: relative;
  .top {
    display: flex;
    justify-content: center;
    margin-bottom: 0.2rem;
    border-bottom: 0.03rem solid;
    @include border_color('border-bottom-color');
    height: 0.5rem;
    font-size: 0.15rem;
    .tabName {
      width: 3rem;
      height: 0.5rem;
      font-weight: 700;
      //line-height: 40px;
      text-align: center;
      //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tabNameActive {
      color: #409EFF;
      border-bottom: 0.03rem solid #409EFF;
    }
  }
  .tips {
    position: absolute;
    bottom: 0.1rem;
    right: 0.4rem;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .keys {
    height: calc(100% - 0.7rem);
    overflow: auto;
    .fastBtn {
      .el-button {
        border-width: 0.01rem;
        padding: 0.12rem 0.2rem;
        font-size: 0.14rem;
        border-radius: 0.04rem;
      }
    }
    .keysIn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 0.3rem;
      overflow: auto;
      //height: 100%;
      min-width: 15rem;
      h4 {
        margin: 0.01rem 0;
      }
      .btns_box {
        display: flex;
        align-items: center;
        .btns {
          display: flex;
          width: 9.13rem;
          flex-wrap: wrap;
          font-size: 0.24rem;
          .letter {
            .button_out {
              display: inline-block;
              padding: 0.05rem;
              width: 0.5rem;
              height: 0.5rem;
              box-sizing: border-box;
              .alphabet-button {
                @include background_color('background_color_key');
                @include border_color('border_color_key');
                @include font_color('font_color');
                border: 0.02rem solid;
                flex: 0 0 0.56rem;
                width: 100%;
                height: 100%;
                //margin: 5px;
                padding: 0;
                font-size: 0.12rem;
                font-weight: 700;
                border-radius: 0.05rem;
                white-space: normal; /* 允许文字换行 */
                word-wrap: break-word; /* 换行时在单词内部断开 */
                overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                .iconBox {
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }
              .alphabet-button:hover {
                @include border_color('border_color_key_hover');
                @include font_color('font_color_hover')
              }
            }
            .keyBig1 {
              width: 1rem !important;
            }
            .keyBig2 {
              width: 0.75rem !important;
            }
            .keyBig3 {
              width: 0.875rem !important;
            }
            .keyBig4 {
              width: 1.125rem !important;
            }
            .keyBig5 {
              width: 0.625rem !important;
            }
            .keyBig6 {
              width: 3.125rem !important;
            }
            .keyBig7 {
              width: 1.375rem!important;
            }
            .keyBig8 {
              height: 1rem;
            }
            .interval1 {
              margin-right: 0.25rem;
            }
            .interval2 {
              margin-right: 0.5rem;
            }
            .interval3 {
              margin-right: 0.25rem;
            }
            .interval4 {
              margin-right: 0.125rem;
            }
            .interval5 {
              margin-right: 0.5rem;
              margin-left: 0.625rem;
            }
            .interval6 {
              margin-right: 0.5rem;
              margin-bottom: 0.125rem;
            }
            .interval7 {
              margin-right: 1.625rem;
            }
          }
        }
        .btns_other {
          width: 1.5rem !important;
          padding-top: 0.625rem;
          margin-left: 0.125rem !important;
        }
        .btns_pad {
          width: 0.5rem !important;
          padding-top: 0.625rem;
        }
        .btns_feature {
          width: 2.8rem !important;
          height: 50%;
          margin-left: 0.2rem;
        }
        .btns_mouse {
          margin-left: 0.2rem;
        }
        .keys {
          display: flex;
        }
        .el-divider--vertical {
          height: 4rem;
          @include background_color('background_color2');
          width: 0.02rem;
          margin: 0 0.1rem;
        }
        .group {
          width: 7rem;
          height: 5rem;
          position: relative;
          .groupOriginSwitch {
            display: flex;
            align-items: center;
            justify-content: space-between;
            //border-bottom: 0.03rem solid rgba(255, 31, 31, 0.1);
            padding-bottom: 0.2rem;
            h4 {
              font-size: 0.15rem;
              @include font_color('font_color3');
              margin-right: 0.1rem;
            }
          }
          .button {
            font-size: 0.18rem;
            letter-spacing: 0.02rem;
            display: inline-block;
            text-align: center;
            padding: 0.1rem 0.2rem;
            //border: 0.02rem solid #D43A3A;
            //box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.16), 0 0.03rem 0.06rem rgba(0, 0, 0, 0.1);
            border: none;
            border-radius: 0.03rem;
            position: relative;
            color: #ffffff;
            background-color: #409EFF;
            font-weight: bold;
            text-transform: uppercase;
            text-decoration: none;
            transition: 0.3s ease all;
            z-index: 1;
          }
          .button:active {
            transform: scale(0.9);
          }
          .button:first-child {
            margin-right: 0.3rem;
          }
          .groupBoxs {
            display: flex;
            justify-content: space-evenly;
            padding-top: 0.1rem;
            .box {
              position: relative;
              .box_top {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 0.7rem;
                height: 0.7rem;
                font-size: 0.2rem;
                border-radius: 0.05rem;
                border: 0.02rem solid #888888;
                @include font_color('font_color');
                //font-family: 'MyFont';
                white-space: normal; /* 允许文字换行 */
                word-wrap: break-word; /* 换行时在单词内部断开 */
                overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                p {
                  text-align: center;
                  width: 100%;
                  white-space: normal; /* 允许文字换行 */
                  word-wrap: break-word; /* 换行时在单词内部断开 */
                  overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                }
              }
              .box_top:hover {
                border-color: #409EFF !important;
                color: #409EFF !important;
              }
              .box_top.box_top_select {
                border-color: #409EFF !important;
                color: #409EFF !important;
              }
              .box_bottom {
                position: absolute;
                top: -0.06rem;
                right: -0.06rem;
                img {
                  width: 0.21rem;
                  height: 0.21rem;
                }
              }
            }
          }
          .groupButtons {
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .DKSBoxs {
            width: 100%;
            .box {
              display: flex;
              align-items: center;
              width: 100%;
              .keyButton {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 0.6rem;
                height: 0.6rem;
                font-size: 0.18rem;
                margin: 0.1rem;
                border-radius: 0.05rem;
                border: 0.02rem solid #888888;
                @include font_color('font_color');
                //font-family: 'MyFont';
                white-space: normal; /* 允许文字换行 */
                word-wrap: break-word; /* 换行时在单词内部断开 */
                overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                p {
                  text-align: center;
                  width: 100%;
                  white-space: normal; /* 允许文字换行 */
                  word-wrap: break-word; /* 换行时在单词内部断开 */
                  overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                }
                .box_bottom {
                  position: absolute;
                  top: -0.06rem;
                  right: -0.08rem;
                  img {
                    width: 0.21rem;
                    height: 0.21rem;
                  }
                }
              }
              .keyButton:hover {
                border-color: #409EFF !important;
                color: #409EFF !important;
              }
              .keyButton.keyButton_select {
                border-color: #409EFF !important;
                color: #409EFF !important;
              }
              .keyDKSModeBox {
                display: flex;
                align-items: center;
                margin-left: 0.7rem;
                .keyDKSMode {
                  display: flex;
                  align-items: center;
                  position: relative;
                  .icon {
                    i {
                      font-size: 0.2rem;
                      color: #888888;
                    }
                  }
                  .line {
                    width: 1.2rem;
                    border-top: 0.03rem #888888 dashed;
                  }
                  .select {
                    position: absolute;
                    width: 1rem;
                    bottom: -0.3rem;
                    left: 0.1rem;
                    transform: translateX(-50%);
                  }
                  .journey {
                    width: 1rem;
                    position: absolute;
                    top: -0.3rem;
                    left: 0.2rem;
                    transform: translateX(-50%);
                    font-size: 0.15rem;
                    @include font_color('font_color3');
                  }
                  .journey:hover {
                    color: #409EFF !important;
                  }
                  .cover {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0;
                    height: 0.2rem;
                    border-radius: 0.1rem;
                    background-color: #409EFF;
                    z-index: 2;
                  }
                }
              }
            }
          }
          .DKSTime {
            display: flex;
            font-size: 0.12rem;
            @include font_color('font_color3');
            margin-bottom: 0.2rem;
            padding-top: 0.1rem;
            .select {
              width: 1.5rem;
              margin-right: 0.2rem;
              label {
                margin-bottom: 0.1rem;
              }
            }
            .originSwitch {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-left: 0.03rem solid rgb(205, 210, 224);
              padding-left: 0.1rem;
              h4 {
                font-size: 0.12rem;
                @include font_color('font_color3');
                margin-right: 0.1rem;
              }
            }
          }
          .Buttons {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 0.3rem;
          }
        }
      }
      .keysCover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background-color: rgba(#fff,0.5);
      }
    }
  }
}
</style>
